import { displayDay, DisplayTime } from 'common/display-state/display-time.js';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { TileBodyHeaderV2 } from 'common/tile/tile-body-header-v2.js';
import { Tile } from 'common/tile/tile.js';
import { LinkRef } from 'components-modules/condition/link-ref.js';
import { IModule } from 'redux-state/layout/types.js';
import { DATE_FORMATS } from 'utilities/date.js';
import { predicateNumber } from 'utilities/isType.js';

interface IForecastSFA {
  date: string;
  lowTemp?: number;
  highTemp?: number;
  temperature?: number;
}

interface ISFAConfig {
  forecasts: IForecastSFA;
  description: string;
}

const Forecast = (props: { forecast: IForecastSFA }) => {
  const {
    forecast: { date, highTemp, lowTemp, temperature },
  } = props;
  return (
    <>
      <h3>
        <span className="u-textUppercase">{displayDay(date, true)}</span>
        &nbsp;
        <DisplayTime classes="u-textRegular" date={date} format={DATE_FORMATS.DateMonth} />
      </h3>

      {temperature && (
        <div className="u-mB-xs">
          <IconWithText
            icon="temp-general"
            classes="IconWithText--vCenter IconWithText--small IconWithText--tight IconWithText--inline"
          >
            <span className="u-textRegular">{temperature}°</span>
          </IconWithText>
        </div>
      )}

      <div className="u-mB-xs">
        {predicateNumber(highTemp) && (
          <IconWithText
            icon="temp-high"
            classes="IconWithText--vCenter IconWithText--small IconWithText--tight IconWithText--inline u-pR-sm"
          >
            <span className="u-textRegular">{highTemp}°</span>
          </IconWithText>
        )}
        {predicateNumber(lowTemp) && (
          <IconWithText
            icon="temp-low"
            classes="IconWithText--vCenter IconWithText--small IconWithText--tight IconWithText--inline"
          >
            <span className="u-textRegular">{lowTemp}°</span>
          </IconWithText>
        )}
      </div>
    </>
  );
};

export const RainForecastSFA = (props: IModule<ISFAConfig & IMapSlotClose>) => {
  const {
    config: { forecasts, description, link },
  } = props;

  return (
    <Tile dataModule="rainforecast-sfa" {...props}>
      <div className="Tile-body">
        <TileBodyHeaderV2
          config={props.config}
          onModuleClose={props.config.onModuleClose}
          modulePath={props.modulePath}
        />

        <p className="fineprint u-mB-0">{description}</p>

        <Forecast forecast={forecasts} />

        <LinkRef link={link} />
      </div>
    </Tile>
  );
};
